import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { of } from 'rxjs';
import { AppConsts } from '@shared/AppConsts';
import { ClaService } from './cla.service';
import { ApplicationService } from '../application/application.service';

@Injectable()
export class ClaStepGuard implements CanActivate {

        constructor(
            private claService: ClaService,
            private applicationService: ApplicationService,
            private router: Router
        ) {
        }

        canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
            // Navigate to first step
            const caseId = this.claService.caseId;
            const step = ClaService.getUrlForStep(this.claService.firstStep);

            const url = `${this.applicationService.getFullCaseUrl()}/wizard/${step}`;
            this.router.navigate([url]);

            return of(true);
        }
}
